import React from "react";
import { Grid, MenuItem, Select, FormControl, makeStyles } from "@material-ui/core";

const MESES = [
  { value: 1, label: "Enero" },
  { value: 2, label: "Febrero" },
  { value: 3, label: "Marzo" },
  { value: 4, label: "Abril" },
  { value: 5, label: "Mayo" },
  { value: 6, label: "Junio" },
  { value: 7, label: "Julio" },
  { value: 8, label: "Agosto" },
  { value: 9, label: "Septiembre" },
  { value: 10, label: "Octubre" },
  { value: 11, label: "Noviembre" },
  { value: 12, label: "Diciembre" },
];

// No se permite seleccionar un periodo anterior a julio 2026.
const ANIO_MINIMO = 2026;
const MES_MINIMO = 7; // Julio

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(2.5),
  },
  formControl: {
    minWidth: 150,
  },
  select: {
    color: "#f5f7fb",
    background: "#111a2b",
    borderRadius: 8,
    fontSize: 14,
    fontWeight: 600,
    "& .MuiSelect-select": {
      padding: "10px 14px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1d3454",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1ea7ff",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1ea7ff",
    },
  },
  icon: {
    color: "#b8cdf0",
  },
  menuPaper: {
    background: "#0b1220",
    border: "1px solid #1d3454",
    borderRadius: 8,
    marginTop: 4,
    "& .MuiList-root": {
      padding: "6px 0",
    },
    "& .MuiMenuItem-root": {
      color: "#d7e3f7",
      fontSize: 14,
    },
    "& .MuiMenuItem-root:hover": {
      background: "#16233d",
    },
    "& .MuiMenuItem-root.Mui-selected": {
      background: "#1a2e4a",
      color: "#4fd1ff",
    },
    "& .MuiMenuItem-root.Mui-selected:hover": {
      background: "#1a2e4a",
    },
    "&::-webkit-scrollbar": {
      width: 8,
    },
    "&::-webkit-scrollbar-track": {
      background: "#0b1220",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#2a3a5c",
      borderRadius: 8,
    },
  },
}));

const SelectorMesAnio = ({ mes, anio, onMesChange, onAnioChange, aniosAtras = 5 }) => {
  const classes = useStyles();
  const anioActual = new Date().getFullYear();
  const anios = Array.from({ length: aniosAtras }, (_, i) => anioActual - i).filter(
    (item) => item >= ANIO_MINIMO,
  );

  // En el anio minimo (2026) solo se puede elegir desde julio en adelante;
  // en cualquier otro anio (siempre mayor) se ven los 12 meses.
  const meses =
    anio === ANIO_MINIMO ? MESES.filter((item) => item.value >= MES_MINIMO) : MESES;

  const handleAnioChange = (nuevoAnio) => {
    onAnioChange(nuevoAnio);
    if (nuevoAnio === ANIO_MINIMO && mes < MES_MINIMO) {
      onMesChange(MES_MINIMO);
    }
  };

  const menuProps = {
    classes: { paper: classes.menuPaper },
    PaperProps: { style: { maxHeight: 320 } },
    getContentAnchorEl: null,
  };

  return (
    <Grid container spacing={2} className={classes.root}>
      <Grid item>
        <FormControl variant="outlined" size="small" className={classes.formControl}>
          <Select
            className={classes.select}
            classes={{ icon: classes.icon }}
            value={mes}
            onChange={(event) => onMesChange(Number(event.target.value))}
            MenuProps={menuProps}
          >
            {meses.map((item) => (
              <MenuItem key={item.value} value={item.value}>
                {item.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item>
        <FormControl variant="outlined" size="small" className={classes.formControl}>
          <Select
            className={classes.select}
            classes={{ icon: classes.icon }}
            value={anio}
            onChange={(event) => handleAnioChange(Number(event.target.value))}
            MenuProps={menuProps}
          >
            {anios.map((item) => (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default SelectorMesAnio;
